__turbopack_context__.v({
  "product-tag-list": "ProductTagList-module-scss-module__9IGhKa__product-tag-list",
  "product-tag-list__icon": "ProductTagList-module-scss-module__9IGhKa__product-tag-list__icon",
  "product-tag-list__item": "ProductTagList-module-scss-module__9IGhKa__product-tag-list__item",
});
